import React from 'react';
import { Box } from '@mui/material';
import ComingSoonImg from '../Assets/comingSoon.png';

const ComingSoon = () => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
    //   minHeight="100vh"
      textAlign="center"
      bgcolor="transparent"
      px={2}
      py={2}
    >
      {/* Illustration */}
      <Box maxWidth={400} mb={4}>
        <img
          src={ComingSoonImg}
          alt="Coming Soon Illustration"
          style={{ width: '100%', height: 'auto' }}
        />
      </Box>
    </Box>
  );
};

export default ComingSoon;
